import { Texture } from 'pixi.js';
import { PixiAssets } from './loadResources';

export const getGameImages = (): Record<string, Texture> => {
  return {
    ...(PixiAssets.cache.has('jackpot') ? PixiAssets.get('jackpot')?.textures || {} : {}),
    ...(PixiAssets.cache.has('boostedJackpotIconInfoBoard') ? PixiAssets.get('boostedJackpotIconInfoBoard')?.textures || {} : {}),
  };
};
